import React from "react";
import parse from "html-react-parser";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useContent } from "contexts/contentContext/contentContext.js";

import "./suspendedUserModal.scss";

const SuspendedUserModal = () => {
  const { getTextByKey } = useContent();

  const text = getTextByKey("blocked-email-text").replace(
    "#user-email-adress#"
  );

  return (
    <div className="simple-content-container">
      <div className="simple-content-title title">
        {getTextByKey("blocked-email-title")}
      </div>
      <div className="simple-content-message">{parse(text)}</div>
      <div className="buttons-container">
        <LinkToNewTab page="contact-us" classes={"jm-button link-button"}>
          {getTextByKey("contact-support")}
        </LinkToNewTab>
      </div>
    </div>
  );
};

export default SuspendedUserModal;
